module.exports = __webpack_public_path__ + "static/media/hyderabad.0507601d.svg";